import { fetchVakNL } from '@vakantiesnl/services/src/util/vaknl-fetch';
import type { IVariant } from 'unleash-proxy-client';

export interface FeatureToggle {
	[key: string]: {
		isEnabled: boolean;
		variant: IVariant;
	};
}

export const createFeatureToggleRequest = (origin: string): RequestInfo =>
	new Request(`${origin}/api/features`, {
		method: 'GET',
	});

export const fetchFeaturesAPI = (origin: string): Promise<FeatureToggle | undefined> => {
	return fetchVakNL({
		input: createFeatureToggleRequest(origin),
	})
		.then((res) => {
			if (!res.ok) {
				return undefined;
			}
			return res.json();
		})
		.catch((err) => {
			throw err;
		});
};
